export const calculateHour = {
  methods: {
    calculateHour(min) {
      const roundedMin = Math.round(min)
      const hour = Math.floor(roundedMin / 60)
      const minutes = roundedMin % 60
      return `${hour}:${minutes}`
    },
  },
}
